import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { AppsOutlined } from '@mui/icons-material';
import { SectionHeaderWithCommand, SectionPaper } from '../../../../common/components';
import { ApplicationTypeEditor, AppTitleEditor, AppDescriptionEditor } from '../fields/customApplication';
import { EditorMode } from '../../../types/editorTypes';

interface CustomApplicationSectionProps {
  mode?: EditorMode;
}

/**
 * CustomApplicationSection - Section for custom application request fields
 * Shown when ticket/recurring task category is "Custom Application"
 */
export const CustomApplicationSection: React.FC<CustomApplicationSectionProps> = ({ mode = 'ticket' }) => {
  const title = mode === 'recurringTask' ? 'Custom Application Request Template' : 'Custom Application Request';

  return (
    <Box>
      <SectionHeaderWithCommand
        icon={<AppsOutlined sx={{ mr: 1, color: '#3b82f6', fontSize: 18 }} />}
        title={title}
      />
      
      <SectionPaper>
        <Stack spacing={3}>
          {/* Application Selection */}
          <Box>
            <Typography 
              variant="body2" 
              sx={{ 
                mb: 1, 
                fontWeight: 500, 
                color: '#64748b' 
              }}
            >
              Application
            </Typography>
            <ApplicationTypeEditor mode={mode} />
          </Box>
          
          {/* Title and Description */}
          <Box>
            <Typography 
              variant="body2" 
              sx={{ 
                mb: 1, 
                fontWeight: 500, 
                color: '#64748b' 
              }}
            >
              Request Details
            </Typography>
            <Stack spacing={2}>
              <AppTitleEditor mode={mode} />
              <AppDescriptionEditor mode={mode} />
            </Stack>
          </Box>
        </Stack>
      </SectionPaper>
    </Box>
  );
};

export default CustomApplicationSection;
